export const IntegrationProvider = {
    Jira: 'jira',
    Zapier: 'zapier',
    SalesForce: 'salesforce',
    Slack: 'slack',
    Workato: 'workato',
    Hubspot: 'hubspot',
    Netsuite: 'netsuite'
};
export const IntegrationConsumer = {
    Rocketlane: 'rocketlane'
};
